const collectionFilters = {
    modalScrollTop: 0,
    modalInner: null,

    init: () => {
        document.querySelector('body').addEventListener('click', e => {
            const groupHeaders = document.querySelectorAll('.filters__group-header');
    
            groupHeaders.forEach(groupHeader => {
                if (e.target === groupHeader) {
                    e.target.closest('.filters__group').classList.toggle('active');
                }
            });
        });
    
        document.addEventListener('scroll', function(e) {
            collectionFilters.stickyForm();
        });
    
        document.addEventListener('resize', function(e) {
            collectionFilters.stickyForm();
        });

        collectionFilters.stickyForm();
        collectionFilters.modalScrollInit();
    },

    stickyForm: () => {
        const header = document.querySelector('section[data-section-id="header"]');
        const filterForm = document.querySelector('#CollectionFiltersForm');
        const filterFormInner = document.querySelector('#CollectionFiltersFormInner');
        const filterFormOffset = header.offsetHeight + filterForm.offsetTop - filterForm.offsetHeight;

        filterFormInner.style.top = (header.offsetHeight - 1) + 'px';
        
        if (window.pageYOffset >= filterFormOffset) {
            filterFormInner.classList.add('sticky-form');
            filterForm.style.height = filterFormInner.offsetHeight + 'px';
        } else {
            filterFormInner.classList.remove('sticky-form');
            filterForm.style.height = 'auto';
        }
    },

    modalScrollInit: () => {
        collectionFilters.modalInner = document.querySelector('#filters .filters__inner');

        collectionFilters.modalInner.addEventListener('scroll', function(e) {
            collectionFilters.modalScrollTop = e.target.scrollTop;
        });

        collectionFilters.modalScroll();
    },

    modalScroll: () => {
        collectionFilters.modalInner.scroll(0, collectionFilters.modalScrollTop);
    }
};

collectionFilters.init();